import {
  browserAnonymousApi,
  type BrowserAnonymousApiClient,
} from "@gain/common-client/browser/anonymous";
import { initApi } from "#shared/api/common-api.ts";
import type { AuthStore } from "#shared/store/auth-store.tsx";

export function initAnonymousApi(authStore: AuthStore): void {
  initApi(authStore);
}

export const anonymousApi: BrowserAnonymousApiClient = browserAnonymousApi;
